var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "company-switcher__option",
      class: { "is-selected": _vm.selected, "is-active": _vm.active },
      attrs: { role: "option", "aria-selected": _vm.active ? "true" : "false" },
    },
    [
      _c("span", { staticClass: "company-switcher__option-label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm.selected
        ? [
            _c("lucide-icon", {
              staticClass: "company-switcher__option-check",
              attrs: { icon: _vm.icons.check, size: 16, "aria-hidden": "true" },
            }),
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm.$t("empresaatual"))),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }